import {useAppSelector} from "hooks/useAppSelector";
import { useLocation } from 'react-router-dom';

export function useLangNavigate() {
  const locale = useAppSelector((state) => state.config.locale);
  const currentLang = locale || '';
  const location = useLocation();

  function langNavigate(path: string, preserveQuery = true): string {
    let search = '';

    if (preserveQuery) {
      const params = new URLSearchParams(location.search);
      const filteredParams = new URLSearchParams();

      ['campaign', 'stag'].forEach((key) => {
        const value = params.get(key);
        if (value !== null) {
          filteredParams.set(key, value);
        }
      });

      const queryString = filteredParams.toString();
      if (queryString) {
        search = `?${queryString}`;
      }
    }

    // Если язык дефолтный 'en', убираем /en из начала пути
    let pathWithoutLang = path;

    if (currentLang === 'en') {
      // если путь начинается с /en, убрать этот сегмент
      if (path.startsWith('/en/')) {
        pathWithoutLang = path.replace(/^\/en/, '');
      } else if (path === '/en') {
        pathWithoutLang = '/';
      }
      // Возвращаем путь без /en и с query
      return `${pathWithoutLang}${search}`;
    }

    // Если язык НЕ дефолтный, добавляем его в начало пути, если нет
    if (path.startsWith(`/${currentLang}`)) {
      return `${path}${search}`;
    } else {
      return `/${currentLang}${path.startsWith('/') ? path : '/' + path}${search}`;
    }
  }

  return langNavigate;
}
